import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Sidebar />
      <main className="pt-16 sm:ml-64 min-h-screen">
        <div className="p-3 sm:p-4 lg:p-6 pb-12">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Layout
